import { createReducer, on } from '@ngrx/store';

import { IDataConfig } from '../../shared/models/ParaTi.model';
import { errorParaTi, getParaTi, successParaTi } from '../actions';


export interface ParaTiState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: IDataConfig;
}

export const ParaTiInit: ParaTiState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: {
        contenido: {
            todo: [],
            noticias: [],
            promos: []
        },
        configuracion: null
    }
};

const _paraTiReducer = createReducer(ParaTiInit,
    on(getParaTi, (state, { api }) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
            api
        }
    )),
    on(successParaTi, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data
        }
    )),
    on(errorParaTi, (state, { payload }) => (
        {
            ...state,
            loading: false,
            failed: true,
            error: { ...payload }
        }
    ))
);

export function ParaTiReducer(state: any, action: any) {
    return _paraTiReducer(state, action);
}